
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Industries from './components/Industries';
import Partners from './components/Partners';
import CTA from './components/CTA';
import BookingForm from './components/BookingForm';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.patriotdt.com';
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${siteUrl}/#organization`,
          "name": "Patriot Defense Technologies",
          "url": siteUrl,
          "logo": {
            "@type": "ImageObject",
            "url": `${siteUrl}/logo.png`
          },
          "description": "Patriot Defense Technologies delivers enterprise IT solutions including cloud services, cybersecurity, AI analytics, and digital transformation for defense and government sectors.",
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "adam@patriotdt.com",
            "contactType": "Customer Service",
            "availableLanguage": "English"
          },
          "sameAs": [
            "https://www.linkedin.com/company/patriot-defense-technologies",
            "https://twitter.com/patriotdt"
          ]
        },
        {
          "@type": "WebSite",
          "@id": `${siteUrl}/#website`,
          "url": siteUrl,
          "name": "Patriot Defense Technologies",
          "publisher": { "@id": `${siteUrl}/#organization` }
        },
        {
          "@type": "WebPage",
          "@id": `${siteUrl}/#webpage`,
          "url": siteUrl,
          "name": "Patriot Defense Technologies | IT & Cybersecurity Solutions",
          "description": "Patriot Defense Technologies delivers enterprise IT solutions including cloud services, cybersecurity, AI analytics, and digital transformation for defense and government sectors.",
          "isPartOf": { "@id": `${siteUrl}/#website` },
          "about": { "@id": `${siteUrl}/#organization` }
        }
      ]
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    document.title = 'Patriot Defense Technologies | IT & Cybersecurity Solutions';
    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Industries />
      <Partners />
      <CTA />
      <BookingForm />
      <Footer />
    </div>
  );
}
